import { variables } from '@bitrise/bitkit';
import { VizContext } from '@bitrise/bitviz';
import { motion } from 'framer-motion';
import React, { useContext, FunctionComponent } from 'react';

interface Props {
  paddingBottom?: number;
  paddingTop?: number;
  x: null | number;
}

const SessionVisualisationTracker: FunctionComponent<Props> = (props) => {
  const { paddingBottom = 0, paddingTop = 0, x, ...rest } = props;

  const { artboardBottom, artboardLeft, artboardRight, artboardTop, getX, transition } = useContext(
    VizContext,
  );

  const px = getX(x);

  if (px === null) {
    return null;
  }

  return (
    <motion.g
      {...rest}
      animate={{ opacity: x === null ? 0 : 1 }}
      opacity="0"
      stroke={variables.colorGray5}
      style={{ pointerEvents: 'none' }}
      transform={`translate(${Math.max(artboardLeft, Math.min(artboardRight, px))}, ${
        artboardTop - paddingTop
      })`}
      transition={transition}
    >
      <line x1="-4" x2="4" y1="0" y2="0" />

      <line
        strokeDasharray="4 4"
        strokeWidth="1"
        y1="0"
        y2={artboardBottom + paddingTop + paddingBottom}
      />

      <line
        x1="-4"
        x2="4"
        y1={artboardBottom + paddingTop + paddingBottom}
        y2={artboardBottom + paddingTop + paddingBottom}
      />
    </motion.g>
  );
};

export default SessionVisualisationTracker;
